export default {
  cn: {
    select: {
      uncoveredPosition: '未平仓交易',
      all: '所有',
      today: '今天',
      triduum: '最近三天',
      hebdomad: '最近一周',
      oneMonth: '最近一个月',
      transactionType: '交易类型',
      tiemText: '时间周期',
      tiema: '时间周期',
      tiemb: '时间周期',
    }
  },
  hk: {
    select: {
      uncoveredPosition: '未平倉交易',
      all: '所有',
      today: '今天',
      triduum: '最近三天',
      hebdomad: '最近一周',
      oneMonth: '最近一個月',
      transactionType: '交易類型',
      tiemText: '時間週期',
      tiema: '時間週期',
      tiemb: '時間週期',
    }
  },
  en: {
    select: {
      uncoveredPosition: 'uncoveredPosition',
      all: 'all',
      today: 'today',
      triduum: 'triduum',
      hebdomad: 'hebdomad',
      oneMonth: 'oneMonth',
      transactionType: 'transactionType',
      tiemText: 'tiemText',
      tiema: 'tiema',
      tiemb: 'tiemb',
    }
  }
}



// WEBPACK FOOTER //
// ./src/MultiLanguage/select.js